define("ember-svg-jar/inlined/image", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path d=\"M5 21.25c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 013 19.25v-14c0-.55.196-1.02.587-1.413A1.926 1.926 0 015 3.25h14c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0119 21.25H5zm0-2h14v-14H5v14zm1-2h12l-3.75-5-3 4-2.25-3-3 4z\"/>",
    "attrs": {
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});